<app-dialog-heading [heading]="displayHeading"></app-dialog-heading>

<div>
  <div class="flex justify-end">
    <app-copy-to-clipboard-button [buttonText]="buttonText" [payload]="displayText"></app-copy-to-clipboard-button>
  </div>
  <ng-container *ngIf="displayText">
    <pre class="content-display-code" [innerHTML]="displayText | prettyPrintText: contentType"></pre>
  </ng-container>
</div>
